import { createAsyncThunk } from '@reduxjs/toolkit';
import userApi from '~/apis/user';
import { CHANGE_PASSWORD, GET_USER_PROFILE, UPDATE_USER_PROFILE } from '~/utils/constants/actionType';

export const getProfile = createAsyncThunk(GET_USER_PROFILE, async (_, { rejectWithValue }) => {
  try {
    const resp = await userApi.getProfile();
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateProfile = createAsyncThunk(
  UPDATE_USER_PROFILE,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const resp = await userApi.updateProfile(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changePassword = createAsyncThunk(
  CHANGE_PASSWORD,
  async (body: { currentPassword: string; newPassword: string }, { rejectWithValue }) => {
    try {
      const resp = await userApi.changePassword(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
